import moment from "moment";
import MmBasicInfoDialog from '../components/MmBasicInfoDialog.vue';

export default {
  data() {
    return {
      isShowMm: false,
      toDialoMmPatientsData: {},
      openMmId: null,
      mmNumberFields: [
        'initial_dark_spot_length', 'initial_dark_spot_width', 'intvl_spot_to_mm_dx_months',
        'lesion_len_initial_tx', 'lesion_wid_initial_tx', 'breslow_thick_first_surg',
        'total_surg_cnt_local_5cm', 'adj_tx_chemo_months', 'adj_tx_radio_count',
        'ifn_alpha1b_ae_max_temp', 'pd1_tx_total_count',
        'lab_blood_routine_wbc', 'lab_blood_routine_rbc', 'lab_blood_routine_hb', 'lab_blood_routine_plt',
        'lab_liver_func_alt', 'lab_liver_func_ast', 'lab_liver_func_tbil',
        'lab_thyroid_imm_tsh', 'lab_hormone_cortisol'
      ],
      mmDateFields: [
        'visit_date', 'time_of_dark_spot_discovery', 'date_of_confirmed_diagnosis',
        'date_of_first_surgery', 'earliest_meta_time', 'current_meta_discovery_time',
        'ifn_alpha1b_initial_date', 'pd1_tx_initial_date', 'pd1_tx_last_date',
        'tmz_anlotinib_date', 'tmz_anlotinib_last_date',
        'viti_concomitant_onset_date', 'viti_concomitant_impr_date',
        'create_time', 'update_time'
      ],
    }
  },
  components: {
    MmBasicInfoDialog
  },
  methods: {
    async newMm(event, item) {
      event.cancelBubble = true;
      this.toDialoMmPatientsData = item;
      this.isShowMm = true;
    },
    setMmStatus(data) {
      this.isShowMm = data;
      if (!data) {
        this.openMmId = null;
      }
    },
    getMm(elId,isedit,patientData) {
      this.openMmId = elId;
      this.isShowMm = true;
      this.toDialoMmPatientsData = patientData;
      this.mmIsEdit = isedit; // 是否可编辑
    },
    async refreshHandler1(data) {
      // data is {id: mmRecordId} from MmBasicInfoDialog, use patient id for refresh
      await this.changeHandler(Number(this.toDialoMmPatientsData.id));
    },
    transformMmData(data) {
      const newData = {};
      for(let key in data){
        if(this.mmNumberFields.includes(key)){
          if(data[key]===-1 || data[key]===null){
            newData[key] = '';
          }else{
            newData[key] = Number(data[key]);
          }
        }else if(this.mmDateFields.includes(key)){
          if(data[key] && data[key] !== -30610253143000){
            newData[key] = moment(data[key]).format("YYYY-MM-DD");
          }else{
            newData[key] = "";
          }
        }else{
          newData[key] = data[key];
        }
      }
      return newData;
    }
  }
}
